import { render, staticRenderFns } from "./BrandSelect.vue?vue&type=template&id=1a5083de&scoped=true"
import script from "./BrandSelect.vue?vue&type=script&lang=js"
export * from "./BrandSelect.vue?vue&type=script&lang=js"
import style0 from "./BrandSelect.vue?vue&type=style&index=0&id=1a5083de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5083de",
  null
  
)

export default component.exports